import React from "react";
import ReactDOM from "react-dom/client";

/**
 * Stylesheet order matters: tokens/reset first, then the shared UI layer,
 * and only then the per-component sheets that App pulls in. Importing
 * App.css here (rather than inside App.js) guarantees component sheets can
 * override shared rules of equal specificity.
 */
import "./index.css";
import "./styles/App.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
